import React from "react";
import classes from "./StatsSection.module.css";
import CalloutSection from "../../UI/CalloutSection/CalloutSection";
import image from "../../../assets/images/academics-stats.jpg";

const StatsSection = (props) => (
  <CalloutSection image={image} alt="Student working on a project">
    <div className={classes.Row}>
      <div className={classes.Column}>
        <p>
          93% of the students had an INTERNSHIP, SERVICE LEARNING or
          RESEARCH EXPERIENCE by graduation
        </p>
      </div>
      <div className={classes.Column}>
        <p>Our students intern in 35+ different countries</p>
      </div>
    </div>
  </CalloutSection>
);

export default StatsSection;
